import { Component } from "react";
import Headerdash from "../components/headerdash";

export default class Bookinglist extends Component {
    constructor() {
        super();
        this.state = {
            bks: [],
            viewbooking: '<p>Please select the received time</p>'
        }
    }

    loadbooking = (bk, i) => {
        let nbs = this.state.bks;
        nbs.map(n => {n.cls = false; return n});
        nbs[i]['cls'] = true;
        bk = bk + '';
        bk = bk.replace('.', '-');
        fetch('https://api.voicecoach.net/viewbooking/' + bk, {credentials: 'include', headers : {'Content-Type':'application/json'}})
        .then(res => res.text())
        .then(rb => {this.setState({viewbooking: rb, bks: nbs})})
    }

    componentDidMount() {
        fetch('https://api.voicecoach.net/bookinglist', {credentials: 'include', headers : {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(rj => {this.setState({ bks: rj})})
    }

    render() {
        let r = this.state.bks;
        r = r.map((rm, i) => <div key={rm.ts} className={rm.cls ? "card my-3 rm ps-3 py-2 active" : "card my-3 rm ps-3 py-2"} onClick={() => { this.loadbooking(rm.ts, i) }}>{rm.st}</div>)
        return <><Headerdash />
        <section className="container">
            <div className="row">
                <div className="col-4">
                    {r}
                </div>
                <div className="col-8">
                    <div className="mt-5">
                    <div dangerouslySetInnerHTML={{__html: this.state.viewbooking}} />
                    </div>
                </div>
            </div>
        </section>
        </>
    }
}
